/**
 * Одноразовый флаг подавления сохранения шаблона при размонтировании.
 *
 * Редактор шаблона (ProjectTemplateManager) сохраняет своё состояние на unmount.
 * Когда ассистент изменил шаблон напрямую в БД, родитель принудительно ремонтирует
 * вкладку через смену :key — уходящий экземпляр держит УСТАРЕВШЕЕ состояние и его
 * autosave затрёт изменения ассистента. Родитель выставляет флаг перед ремаунтом,
 * уходящий экземпляр проверяет его в хуке unmount и пропускает сохранение.
 */

let skipNextUnmountSave = false;

export function skipNextTemplateUnmountSave() {
    skipNextUnmountSave = true;
}

export function consumeTemplateUnmountSaveSkip() {
    const value = skipNextUnmountSave;
    skipNextUnmountSave = false;
    return value;
}
